import { type ComponentProps } from 'react';
import { OffboardingToWarehouseModal as OffboardingToWarehouseModalView } from '../NewOffboardingToWarehouseModal/OffboardingToWarehouseModal';

export type OffboardingToWarehouseModalProps = ComponentProps<typeof OffboardingToWarehouseModalView>;

/**
 * Modal de offboarding a bodega con panel lateral (`BordLateralModal`).
 */
export const OffboardingToWarehouseModal = (props: OffboardingToWarehouseModalProps) => {
  return <OffboardingToWarehouseModalView {...props} />;
};
